
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1346","height":"1345","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M415.946 929.886C169.436 683.405 31.358 369.67 1.202 47.709c-3.739-39.815 43.84-62.83 72.133-34.532L1332.8 1272.46c27.81 27.85 5.69 75.86-33.48 72.22-322.381-29.93-636.554-168.04-883.374-414.794z","fill":"#F05245"}})])
          )
        }
      }
    